//Create base instance
import axios from 'axios';
import { Auth } from 'aws-amplify';

import { completeSignIn } from './actions/auth';

let localeStr;
// Check localStorage for locale, if zh-cn, set to zh
if (process.env.APP_ENV !== 'production') {
  localeStr = localStorage.getItem('i18nextLng')
    ? localStorage.getItem('i18nextLng')
    : 'en';
  if (localeStr.toLowerCase() === 'zh-cn') {
    localeStr = 'zh';
  }
} else {
  // Currently for prod, always set locale to English
  localeStr = 'en';
}

const api = axios.create({
  baseURL: process.env.API_URL,
  responseType: 'json',
  headers: {
    'X-LOCALE': localeStr
  }
});

const apiAuth = (apiUrl, method = '', xcsrfToken = '', body = {}) =>
  Auth.currentSession().then(data => {
    const sub = data.accessToken.payload.sub;
    const jwtToken = data.accessToken.jwtToken;
    let authHeaderStr = 'Bearer ' + btoa(jwtToken);
    if (method === 'patch') {
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth': authHeaderStr,
        'X-Sub': sub,
        'X-CSRF-TOKEN': xcsrfToken
      };
      return api.patch(apiUrl, body, { headers });
    } else if (method === 'post') {
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth': authHeaderStr,
        'X-Sub': sub,
        'X-CSRF-TOKEN': xcsrfToken
      };
      return api.post(apiUrl, body, { headers });
    } else if (method === 'put') {
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth': authHeaderStr,
        'X-Sub': sub,
        'X-CSRF-TOKEN': xcsrfToken
      };
      return api.put(apiUrl, body, { headers });
    } else if (method === 'delete') {
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth': authHeaderStr,
        'X-Sub': sub,
        'X-CSRF-TOKEN': xcsrfToken
      };
      return api.delete(apiUrl, { headers });
    }
    return api.get(apiUrl, {
      headers: {
        'X-Auth': authHeaderStr,
        'X-Sub': sub
      }
    });
  });

export { apiAuth };

export default api;
